<template>
  <b-navbar class="header_block" fixed-top shadow transparent spaced type="is-light">
    <template slot="brand">
        <b-navbar-item tag="router-link" :to="{ path: '/' }" class="logo_block">
        <img class="logo" src="../assets/logo_s.svg">
        <span class="main_text">{{ $ml.get('menu_main') }}</span>
      </b-navbar-item>
    </template>
    <template slot="start">
      <div class="header navbar-start">
        <b-navbar-item class="nav_item" tag="router-link" :to="{ path: '/dashboard' }">
          <div class="nav_item">
            <img src="https://ucarecdn.com/a6c7e67c-b052-4244-8528-53d7b94812ba/webdesign_5277589.png"
                 alt="dashboard">
            <span>{{ $ml.get('menu_dashboard') }}</span>
          </div>
        </b-navbar-item>
        <b-navbar-item tag="router-link" :to="{ path: '/rooms' }">
          <div class="nav_item">
            <img src="https://ucarecdn.com/b7ff5e55-f223-4cdc-81ef-c2105743b617/intermediary_4954391.png"
                 alt="accounts">
            <span>{{ $ml.get('menu_accounts') }}</span>
          </div>
        </b-navbar-item>
        <b-navbar-item tag="router-link" :to="{ path: '/public-strategies' }">
          <div class="nav_item">
            <img src="https://ucarecdn.com/d6a12a37-8534-474a-aee7-02ad9f452937/hardware_4786014.png"
                 alt="strategies">
            <span>{{ $ml.get('menu_strategies') }}</span>
          </div>
        </b-navbar-item>
        <b-navbar-item tag="router-link" :to="{ path: '/bets/placed' }">
          <div class="nav_item">
            <img src="https://ucarecdn.com/edb3643c-f0a8-476d-b2d1-a34dd86d130d/pricelist_4954401.png" alt="bets">
            <span>{{ $ml.get('menu_bets') }}</span>
          </div>
        </b-navbar-item>
        <b-navbar-item tag="router-link" :to="{ path: '/statistic/user' }">
          <div class="nav_item">
            <img src="https://ucarecdn.com/8121f0dc-d756-48bc-887b-bceac3e06913/strategy_7430600.png"
                 alt="statistics">
            <span>{{ $ml.get('menu_statistic') }}</span>
          </div>
        </b-navbar-item>
        <b-navbar-item tag="router-link" :to="{ path: '/pages/help' }">
          <div class="nav_item">
            <img src="https://ucarecdn.com/66192747-6d5a-4d1a-90d3-a4d904a9e5e1/education_8262836.png" alt="help">
            <span>{{ $ml.get('menu_help') }}</span>
          </div>
        </b-navbar-item>
        <b-navbar-item tag="router-link" :to="{ path: '/bookies' }"
          v-if="this.$store.getters['auth/user'].ml_group === 'SUPERB'">
          <div class="nav_item">
            <span>{{ $ml.get('menu_bookies') }}</span>
          </div>
        </b-navbar-item>
      </div>
    </template>

    <template slot="end">
      <b-navbar-item tag="router-link" :to="{ path: '/payment' }"
        :class="this.$store.getters['auth/user'].balance < 10 ? 'text-danger' : 'text-success'">
        <div class="wallet_block">
           <img src="../assets//wallet.png" alt="баланс">
            <Money v-bind:amount="this.$store.getters['auth/user'].balance" currency="EUR"></Money>
        </div>
      </b-navbar-item>
      <b-navbar-item>
        <div @click="toggleTheme">
          {{ theme === 'dark' ? '🌙' : '☀️' }}
        </div>
      </b-navbar-item>
      <b-navbar-item @click="logout">
        <div class="logout_block">
          <img src="../assets/logout.png" alt="logout">
           <span>{{ $ml.get('menu_logout') }} {{ this.$store.getters['auth/user'].email }}</span>
        </div>
        
      </b-navbar-item>
      <b-navbar-item>
        <a @click="$ml.change('ru')" title="Русский" style="margin-right: 5px">
          <img src="../assets/ru.png">
        </a>
        <a @click="$ml.change('en')" title="English">
          <img src="../assets/en.png">
        </a>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
import Money from "@/components/Money";
import {ThemeManager} from "../theme";

export default {
  name: "Navbar",
  data() {
    return {
      pulse: null,
      constants: null,
      theme: ThemeManager.getTheme()
    }
  },
  components: {Money},
  methods: {
    logout: function () {
      this.$store.dispatch('auth/logout')
    },
    toggleTheme() {
      this.theme = ThemeManager.toggleTheme()
    }
  },
  mounted() {
    this.$store.dispatch('auth/user_pulse')
    this.pulse = setInterval(() => {
      this.$store.dispatch('auth/user_pulse')
    }, 90000)
    this.constants = setInterval(() => {
      this.$store.dispatch('data/constants')
    }, 3600000)
    ThemeManager.setTheme(this.theme)
  },
  beforeDestroy() {
    clearInterval(this.pulse)
    this.pulse = null
    clearInterval(this.constants)
    this.constants = null
  },
}
</script>

<style scoped>
img {
  width: 30px;
  height: 30px;
}

.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.header img {
  width: 15px;
  height: 15px;
}

.nav_item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

img{
  width: 20px;
  height: 20px;
}

.logo_block{
  display: flex;
  gap: 10px;
}

.wallet_block{
   display: flex;
   align-items: center;
  gap: 7px;
}

.wallet_block img{
  width: 13px;
  height: 13px;
}

.logout_block{
  display: flex;
  gap: 7px;
}


@media (max-width: 850px) {
  .header {
    flex-direction: column;
    align-items: center;
  }
  .main_text{
    display: none;
  }
}
</style>
